/*
 * Riri pre-order warning at checkout — the card in snippets/riri-preorder-checkout.liquid.
 * A press on any Check out button (name="checkout": cart notification, /cart, drawer) is held,
 * the cart is read from /cart.js, and the card opens only if a line is a pre-order.
 * The Essential Pre-order app marks such a line with the property _essential_preorder_campaign_id;
 * its campaign messages come from the app's embed on every page (preorder-app-data).
 * "I understand" presses the same button again, so checkout runs exactly as before.
 * No pre-order line, or /cart.js fails → checkout goes on untouched.
 * Reads only: no amounts, nothing sent; Shopify's checkout does the money part.
 */
(function () {
  if (window.ririPreorderCheckoutLoaded) return; // not a window.<id> name: the card's id is a named global
  window.ririPreorderCheckoutLoaded = true;

  var CHECKOUT = 'button[name="checkout"], input[type="submit"][name="checkout"]';
  var CAMPAIGN_PROP = '_essential_preorder_campaign_id';
  var FETCH_MS = 4000;

  var root, card, list, body, note, okBtn, pending = null, passing = false, busy = false;

  function isVisible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  // Press the same button again, letting both its click and the form submit through once.
  function proceed(btn) {
    if (!btn || !btn.isConnected) return;
    passing = true;
    try { btn.click(); } finally { passing = false; }
  }

  function readCart() {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, FETCH_MS);
    return fetch(root.getAttribute('data-cart-js'), { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .finally(function () { clearTimeout(timer); });
  }

  function isPreorderLine(line) {
    return !!(line && line.properties && line.properties[CAMPAIGN_PROP]);
  }

  // All campaigns the app put on the page: window config first, else its embed's attribute.
  function campaigns() {
    var cfg = window.essentialPreorderConfigs;
    if (cfg && Array.isArray(cfg.preorderCampaigns)) return cfg.preorderCampaigns;
    var embed = document.querySelector('essential-preorder-app-embed[preorder-app-data]');
    try { return (JSON.parse(embed.getAttribute('preorder-app-data')).preorderCampaigns) || []; } catch (e) { return []; }
  }

  // The distinct messages of the cart's pre-order campaigns, in the page language.
  function messages(lines) {
    var ids = {}, seen = {}, out = [], locale = (root.getAttribute('data-locale') || '').toLowerCase();
    lines.forEach(function (l) { ids[String(l.properties[CAMPAIGN_PROP])] = true; });
    campaigns().forEach(function (c) {
      if (!c || !ids[String(c.id)]) return;
      var msg = (c.content && c.content.message) || '';
      (c.contentTranslations || []).forEach(function (t) {
        var tl = String(t.locale || '').toLowerCase();
        if (t.message && (tl === locale || tl.split('-')[0] === locale.split('-')[0])) msg = t.message;
      });
      msg = String(msg).trim();
      if (msg && !seen[msg]) { seen[msg] = true; out.push(msg); }
    });
    return out;
  }

  function imageUrl(src) {
    if (!src) return '';
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=120';
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function fill(lines, mixed) {
    list.textContent = '';
    lines.forEach(function (l) {
      var li = el('li');
      var src = imageUrl(l.image || (l.featured_image && l.featured_image.url));
      if (src) { var img = el('img'); img.src = src; img.alt = ''; img.width = 52; img.height = 52; li.appendChild(img); }
      else li.appendChild(el('span', 'riri-poc__ph'));
      var info = el('div');
      info.appendChild(el('span', 'riri-poc__name', l.product_title || l.title || ''));
      if (!l.product_has_only_default_variant && l.variant_title) info.appendChild(el('span', 'riri-poc__var', l.variant_title));
      li.appendChild(info);
      var q = el('span', 'riri-poc__qty', root.getAttribute('data-text-qty') + ' ');
      q.appendChild(el('bdi', null, String(l.quantity)));
      li.appendChild(q);
      list.appendChild(li);
    });
    body.textContent = root.getAttribute(mixed ? 'data-text-mixed' : 'data-text-only');
    var msgs = messages(lines);
    note.textContent = msgs.join('\n');
    note.hidden = !msgs.length;
  }

  function open(btn, lines, mixed) {
    pending = btn;
    fill(lines, mixed);
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    list.parentNode.scrollTop = 0;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    okBtn.focus();
  }

  function close(confirmed) {
    if (root.hidden) return;
    var btn = pending;
    pending = null;
    root.classList.remove('is-open');
    root.hidden = true;
    document.documentElement.style.overflow = '';
    if (confirmed) proceed(btn);
    else if (btn && btn.isConnected && isVisible(btn)) btn.focus();
  }

  function hold(e, btn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy || !root.hidden) return; // one press, one check
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    readCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var pre = items.filter(isPreorderLine);
      if (!pre.length) return proceed(btn);
      open(btn, pre, pre.length < items.length);
    }, function () {
      proceed(btn); // never block checkout on a failed read
    }).finally(function () {
      busy = false;
      btn.removeAttribute('aria-busy');
    });
  }

  function onClick(e) {
    if (passing || !root || !e.target.closest) return;
    var btn = e.target.closest(CHECKOUT);
    if (!btn || btn.disabled) return;
    hold(e, btn);
  }

  // Enter in a cart field submits through the Check out button without a click.
  function onSubmit(e) {
    if (passing || !root) return;
    var by = e.submitter;
    if (!by || !by.matches || !by.matches(CHECKOUT)) return;
    hold(e, by);
  }

  function onKey(e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(false); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(card.querySelectorAll('button, [tabindex="0"]'), isVisible);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || !card.contains(active))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (active === last || !card.contains(active))) { e.preventDefault(); first.focus(); }
  }

  function init() {
    root = document.getElementById('RiriPreorderCheckout');
    if (!root) return;
    if (root.parentElement !== document.body) document.body.appendChild(root);
    card = root.querySelector('[role="dialog"]');
    list = root.querySelector('[data-riri-poc-items]');
    body = root.querySelector('[data-riri-poc-body]');
    note = root.querySelector('[data-riri-poc-note]');
    okBtn = root.querySelector('[data-riri-poc-ok]');
    okBtn.addEventListener('click', function () { close(true); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-riri-poc-back]'), function (b) {
      b.addEventListener('click', function () { close(false); });
    });
    root.addEventListener('click', function (e) { if (e.target === root) close(false); });
    document.addEventListener('keydown', onKey, true);
  }

  window.addEventListener('click', onClick, true);
  window.addEventListener('submit', onSubmit, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
